import { useEffect } from 'react';
import { Link } from 'react-router-dom';

export default function WorksPage() {
  const works = [
    {
      category: 'AI導入支援',
      categoryColor: 'bg-[#1a2744]',
      title: 'Open Claw導入支援',
      description: '企業へのOpen Claw導入を支援。業務プロセスのヒアリングから導入設計、運用定着まで一貫して伴走。業務効率化と生産性向上を実現しました。',
      image: 'https://images.unsplash.com/photo-1552664730-d307ca884978?w=800&h=600&fit=crop',
    },
    {
      category: 'AI導入支援',
      categoryColor: 'bg-[#1a2744]',
      title: 'Claude Code導入支援',
      description: '開発チームへのClaude Code導入を支援。開発ワークフローの分析を行い、最適な活用方法を提案。コーディング業務の大幅な効率化を実現しました。',
      image: 'https://images.unsplash.com/photo-1498050108023-c5249f4df085?w=800&h=600&fit=crop',
    },
    {
      category: 'AI活用',
      categoryColor: 'bg-[#2563EB]',
      title: 'データ分析・AI活用による業務改善支援',
      description: 'クライアント企業の業務データを分析し、AI活用による業務プロセス最適化を実施。定量的な改善効果を可視化し、継続的な改善サイクルを構築しました。',
      image: 'https://images.unsplash.com/photo-1551288049-bebda4e38f71?w=800&h=600&fit=crop',
    },
    {
      category: 'システム開発',
      categoryColor: 'bg-[#10B981]',
      title: '建築業データ管理システム構築',
      description: '建築業界特有の複雑な業務フローに合わせたデータ管理システムをフルスクラッチで構築。現場と事務所間の情報共有を効率化しました。',
      image: 'https://images.unsplash.com/photo-1541888946425-d81bb19240f5?w=800&h=600&fit=crop',
    },
    {
      category: 'HP制作',
      categoryColor: 'bg-[#F97316]',
      title: 'サクッとHP — 契約5社（福祉業界・飲食業界）',
      description: '福祉業界・飲食業界を中心に、月額3,980円〜の低コスト・高品質なHP制作を提供。5社への導入実績があり、各社の集客力向上に貢献しています。',
      image: 'https://images.unsplash.com/photo-1460925895917-afdab827c52f?w=800&h=600&fit=crop',
    },
    {
      category: 'web3',
      categoryColor: 'bg-[#8B5CF6]',
      title: 'web3マーケティング支援（5社以上）＋自社プロダクト3つ運営',
      description: 'web3プロジェクトのマーケティング戦略策定から実行まで5社以上を支援。自社でも3つのプロダクトを運営し、実践的なノウハウを蓄積しています。',
      image: 'https://images.unsplash.com/photo-1639762681485-074b7f938ba0?w=800&h=600&fit=crop',
    },
    {
      category: 'web3',
      categoryColor: 'bg-[#8B5CF6]',
      title: 'LINE mini dapp マーケティング支援',
      description: 'LINE mini dappプロジェクトにてPM（プロジェクトマネージャー）を担当。企画から開発進行管理まで一貫してプロジェクト成功に貢献しました。',
      image: 'https://images.unsplash.com/photo-1611162617474-5b21e879e113?w=800&h=600&fit=crop',
    },
    {
      category: 'システム開発',
      categoryColor: 'bg-[#10B981]',
      title: 'Telegram・Discordチャットbot導入',
      description: 'コミュニティ運営の効率化を目的に、Telegram・Discord向けのチャットbotを開発・導入。自動応答やモデレーション機能で運営コストを削減しました。',
      image: 'https://images.unsplash.com/photo-1526374965328-7f61d4dc18c5?w=800&h=600&fit=crop',
    },
  ];

  useEffect(() => {
    // Update page title and meta tags
    const siteUrl = import.meta.env.VITE_SITE_URL || 'https://example.com';
    document.title = '実績紹介 | 合同会社Lill - AI導入・システム開発・HP制作の実績';
    
    // Update meta description
    let metaDescription = document.querySelector('meta[name="description"]');
    if (metaDescription) {
      metaDescription.setAttribute('content', 'AI導入支援、システム開発、HP制作、web3支援など、合同会社Lillの実績をご紹介します。Open Claw導入、建築業データ管理システム、サクッとHPなど多数の実績があります。');
    }

    // Update canonical
    let canonical = document.querySelector('link[rel="canonical"]');
    if (canonical) {
      canonical.setAttribute('href', siteUrl + '/works');
    }

    // Update OG tags
    let ogTitle = document.querySelector('meta[property="og:title"]');
    if (ogTitle) {
      ogTitle.setAttribute('content', '実績紹介 | 合同会社Lill');
    }

    let ogDescription = document.querySelector('meta[property="og:description"]');
    if (ogDescription) {
      ogDescription.setAttribute('content', 'AI導入支援、システム開発、HP制作、web3支援など、合同会社Lillの豊富な実績をご紹介します。');
    }

    let ogUrl = document.querySelector('meta[property="og:url"]');
    if (ogUrl) {
      ogUrl.setAttribute('href', siteUrl + '/works');
    }

    // Schema.org JSON-LD for Works page
    const schema = {
      '@context': 'https://schema.org',
      '@type': 'WebPage',
      name: '実績紹介 | 合同会社Lill',
      description: 'AI導入支援、システム開発、HP制作、web3支援など、合同会社Lillの実績をご紹介します。',
      url: `${siteUrl}/works`,
      breadcrumb: {
        '@type': 'BreadcrumbList',
        itemListElement: [
          {
            '@type': 'ListItem',
            position: 1,
            name: 'ホーム',
            item: siteUrl
          },
          {
            '@type': 'ListItem',
            position: 2,
            name: '実績紹介',
            item: `${siteUrl}/works`
          }
        ]
      }
    };

    const script = document.createElement('script');
    script.type = 'application/ld+json';
    script.text = JSON.stringify(schema);
    document.head.appendChild(script);

    return () => {
      document.head.removeChild(script);
    };
  }, []);

  return (
    <div className="min-h-screen bg-white">
      {/* Hero Section */}
      <section className="relative py-24 sm:py-32 lg:py-40 px-4 sm:px-6 overflow-hidden">
        {/* Background Image */}
        <div className="absolute inset-0">
          <img
            src="https://images.unsplash.com/photo-1486406146926-c627a92ad1ab?w=1920&h=1080&fit=crop"
            alt="都市風景"
            className="w-full h-full object-cover object-center"
          />
          <div className="absolute inset-0 bg-[#1a2744]/60"></div>
        </div>

        {/* Hero Content */}
        <div className="relative z-10 max-w-7xl mx-auto text-center">
          <h1 className="text-5xl sm:text-6xl lg:text-7xl font-bold text-white mb-4 tracking-tight">
            WORKS
          </h1>
          <p className="text-xl sm:text-2xl text-white/90">
            実績紹介
          </p>
        </div>
      </section>

      {/* Works Grid Section */}
      <section className="py-20 sm:py-28 px-4 sm:px-6 bg-white">
        <div className="max-w-7xl mx-auto">
          <div className="grid grid-cols-1 lg:grid-cols-2 gap-8 lg:gap-10">
            {works.map((work, index) => (
              <div
                key={index}
                className="group bg-white rounded-lg overflow-hidden border border-gray-200 hover:shadow-xl transition-all duration-300"
              >
                {/* Image */}
                <div className="relative w-full h-72 overflow-hidden">
                  <img
                    src={work.image}
                    alt={work.title}
                    className="w-full h-full object-cover object-center transition-transform duration-500 group-hover:scale-105"
                  />
                  {/* Category Tag */}
                  <div className={`absolute top-4 left-4 px-4 py-2 ${work.categoryColor} text-white text-sm font-semibold rounded whitespace-nowrap`}>
                    {work.category}
                  </div>
                </div>

                {/* Content */}
                <div className="p-8">
                  <h3 className="text-2xl font-bold text-[#1a2744] mb-4 group-hover:text-[#2563EB] transition-colors">
                    {work.title}
                  </h3>
                  <p className="text-gray-600 leading-relaxed">
                    {work.description}
                  </p>
                </div>
              </div>
            ))}
          </div>
        </div>
      </section>

      {/* CTA Section */}
      <section className="py-20 sm:py-28 px-4 sm:px-6 bg-[#F5F7FA]">
        <div className="max-w-4xl mx-auto text-center">
          <h2 className="text-3xl sm:text-4xl lg:text-5xl font-bold text-[#1a2744] mb-8 leading-tight">
            御社の課題もお任せください。
          </h2>
          <Link
            to="/contact"
            className="inline-flex items-center gap-3 px-12 py-5 bg-[#2563EB] text-white font-semibold rounded-md hover:bg-[#1d4ed8] transition-all duration-300 whitespace-nowrap"
          >
            相談する
            <i className="ri-arrow-right-line text-xl"></i>
          </Link>
        </div>
      </section>
    </div>
  );
}